StudentTeachers = new (function () {
  this.setSelects = () => {
    $(".edit_student_teacher #student_teacher_subject").select2({
      allowClear: false,
    });
    $(".edit_student_teacher #student_teacher_teacher_id").select2({
      allowClear: false,
    });

    // ####################################### MANAGE STUDENT TEACHERS PAGE ######################################

    let wrapper = $(".manage-student-teachers");
    let form = wrapper[0]?.querySelector("#st-current-year-select")?.form;

    // Reset filters after reloading page
    $("#st-current-year-select, #st-subject-select, #st-school-select", wrapper).val(null).trigger("change.select2");

    $("#st-school-select", wrapper).select2({
      placeholder: "- Filter by school -",
    });

    $("#st-teacher-select", wrapper).select2({
      placeholder: "- Filter by teacher name -",
      ajax: {
        dataType: "json",
        url: "/teacher_entities/autocomplete",
        delay: 250,
        data: (params) => ({ ...params, current_year: form["current_year"]?.value }),
      },
    });

    $("#st-subject-select", wrapper).select2({
      placeholder: "- Filter by subject -",
    });

    $("#st-current-year-select", wrapper).select2({
      placeholder: "- Filter by current year group -",
      minimumResultsForSearch: Infinity,
    });

    $("#st-student-select", wrapper).select2({
      placeholder: "- Filter by student name -",
      ajax: {
        dataType: "json",
        url: "/student_entities/autocomplete",
        delay: 250,
        data: (params) => ({ ...params, current_year: form["current_year"]?.value }),
      },
    });
  };

  this.bindEvents = () => {
    if ($("#fuzzy-matched-teacher-names").length > 0) {
      $("#fuzzyMatchedTeacherNamesModal").modal({
        backdrop: "static",
        keyboard: false,
      });
    }
  };
})();
